import { html, LitElement } from 'lit';

class D1iNextValidDate extends LitElement {
  static get is() { return 'd1i-next-valid-date'; }

  createRenderRoot() {
    return this;
  }

  static get properties() {
    return {
      timeIntervalOpenings: {
        type: Array,
        attribute: 'time-interval-openings',
      },
      currentDateEntry: {
        type: Object,
        attribute: 'current-date-entry',
        reflect: true,
      },
    };
  }

  constructor() {
    super();
    this.currentDateEntry = null;
    this.timeIntervalOpenings = [];
    this._updateStatus = this._updateStatus.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.timeIntervalOpenings === null || this.timeIntervalOpenings.length === 0) {
      return;
    }
    this._updateStatus();
    this.interval = setInterval(this._updateStatus, 60000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    /** @type {Date} */
    if (this.currentDateEntry) {
      /** @type {Date} */
      const currenDate = this.currentDateEntry;
      const weekDaysShort = 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_');
      const months = 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_');

      return html`
        ${weekDaysShort[currenDate.getDay()]}, ${currenDate.getDate()}. ${months[currenDate.getMonth()]} ${currenDate.getFullYear()} /
        ${currenDate.toTimeString().replace(/.*(^\d{2}:\d{2}).*/, '$1')} Uhr`;
    }
    return html``;
  }

  _updateStatus() {
    const currentDate = new Date();
    for (const openingTimes of this.timeIntervalOpenings) {
      const endDate = D1iNextValidDate._convertDateStringToDate(openingTimes.end?.date);
      if (endDate === null) {
        return;
      }

      if (endDate >= currentDate) {
        this.currentDateEntry = D1iNextValidDate._convertDateStringToDate(openingTimes.start?.date);
        return;
      }
    }
    this.currentDateEntry = null;
  }

  /**
   * @param {string|undefined|null} dateString
   *
   * @return {null|Date}
   */
  static _convertDateStringToDate(dateString) {
    if (typeof dateString !== 'string') {
      return null;
    }

    const dateRegex = /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})/;
    const dateParts = dateString.match(dateRegex);

    if (dateParts === null) {
      return null;
    }

    return new Date(
      parseInt(dateParts[1], 10),
      (parseInt(dateParts[2], 10) - 1),
      parseInt(dateParts[3], 10),
      parseInt(dateParts[4], 10),
      parseInt(dateParts[5], 10),
    );
  }
}

customElements.define(D1iNextValidDate.is, D1iNextValidDate);
